import React from "react";
import IconBase from "./IconBase";
import icon from "./forward.svg";

export default function IconForward({ width, height }) {
  return <IconBase alt="vorwaerts" img={icon} width={width} height={height} />;
}
